import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../Header";
import "../ResetPassword/ResetPassword.css";

const ResetEmail = () => {
    const [formData, setFormData] = useState({
        currentEmail: "",
        newEmail: "",
        confirmEmail: ""
    });
    const [message, setMessage] = useState({ text: "", isError: false });
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const emailFromState = location.state?.email;

    useEffect(() => {
        if (emailFromState) {
            setFormData(prev => ({ ...prev, currentEmail: emailFromState }));
        }
    }, [emailFromState]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
    };

    const validateForm = () => {
        if (!formData.newEmail || !formData.confirmEmail) {
            setMessage({ text: "Both email fields are required", isError: true });
            return false;
        }

        if (formData.newEmail !== formData.confirmEmail) {
            setMessage({ text: "Emails do not match", isError: true });
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.newEmail)) {
            setMessage({ text: "Please enter a valid email address", isError: true });
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ text: "", isError: false });
    
        if (!validateForm()) return;
    
        setLoading(true);
    
        try {
            const response = await fetch(`https://api.hgcdental.clinic/reset-email`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    currentEmail: emailFromState || formData.currentEmail,
                    newEmail: formData.newEmail
                }),
            });
    
            const data = await response.json();
    
            if (!response.ok) {
                throw new Error(data.message || "Failed to update email");
            }
    
            setMessage({ text: "Email updated successfully", isError: false });
            
            // Optional: Redirect after successful update
            setTimeout(() => navigate("/profile"), 2000);
        } catch (error) {
            setMessage({ 
                text: error.message || "Something went wrong. Please try again.", 
                isError: true 
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-content">
                <div className="login-card">
                    <h1 className="login-title">Update Email Address</h1>
                    <form onSubmit={handleSubmit} className="auth-form">
                        <div className="form-group">
                            <label htmlFor="currentEmail">Current Email</label>
                            <input
                                type="email"
                                id="currentEmail"
                                value={formData.currentEmail}
                                onChange={handleInputChange}
                                disabled={!!emailFromState}
                                className="form-input"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="newEmail">New Email</label>
                            <input
                                type="email"
                                id="newEmail"
                                value={formData.newEmail}
                                onChange={handleInputChange}
                                placeholder="Enter new email"
                                className="form-input"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirmEmail">Confirm New Email</label>
                            <input
                                type="email"
                                id="confirmEmail"
                                value={formData.confirmEmail}
                                onChange={handleInputChange}
                                placeholder="Confirm new email"
                                className="form-input"
                                required
                            />
                        </div>

                        {message.text && (
                            <div className={`form-message ${message.isError ? "error" : "success"}`}>
                                {message.text}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="login-button-1"
                            disabled={loading}
                        >
                            {loading ? (
                                <span className="button-loader"></span>
                            ) : (
                                "Update Email"
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ResetEmail;
